<section class="admin-user-edit">
    <div>        
        <div class="form">                
            <form *ngIf="formGroup" [formGroup]="formGroup" autocomplete="off">
                <div class="form-section clear-border">
                    <div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="firstName">First Name</label>
                                    <input type="text" name="firstName" formControlName="firstName" placeholder="First Name" class="form-control">
                                    <sp-field-error [controlName]="'firstName'" [control]="formGroup.controls['firstName']"></sp-field-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="lastName">Last Name</label>
                                    <input type="text" name="lastName" formControlName="lastName" placeholder="Last Name" class="form-control">
                                    <sp-field-error [controlName]="'lastName'" [control]="formGroup.controls['lastName']"></sp-field-error>
                                </div>
                            </div>                                
                        </div>
                        <div class="row"> 
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="email">Email <i class="fa fa-asterisk required"></i></label>
                                    <input type="text" name="email" formControlName="email" placeholder="Email" class="form-control" readonly>
                                    <sp-field-error [controlName]="'email'" [control]="formGroup.controls['email']"></sp-field-error>
                                </div>
                            </div>        
                            <!-- Only visible for internal SmartProperty admin users -->
                            <div class="col-md-6" *ngIf="userProfile?.isSmartPropertyAdmin">
                                <div class="form-group">
                                    <label for="role">Atlas Subscription Type</label>
                                    <select id="role" class="sp-select form-control" formControlName="atlasSubscriptionType">
                                        <option *ngFor="let atlasSubscriptionType of atlasSubscriptionTypes" [ngValue]="atlasSubscriptionType.value"
                                            class="form-control">
                                            {{atlasSubscriptionType.text | customSplitCamelCase}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>                        
                    </div>
                </div>
            </form>
        </div>        

        <footer class="text-end margin-top-20">
            <button type="button" class="btn btn-cancel" (click)="cancelChanges()">Cancel</button>
            <button type="button" class="btn btn-success" (click)="saveUser()" [disabled]="!formGroup?.valid || isSubmitting">Update User</button>
        </footer>

        <section class="margin-top-20 margin-left-20 margin-right-20">
            
            <!-- Portfolios/Workspaces Table -->
            <div class="row">
                <h3>User Portfolios</h3>
                <dx-data-grid
                    #dxAdminUserPortfoliosDataGrid
                    id="adminUserPortfoliosDataGrid"
                    [dataSource]="user?.userWorkspaces"                    
                    [showColumnLines]="false"
                    [showRowLines]="true"
                    [showBorders]="false"
                    (onRowPrepared)="dxGridRowPrepared($event)"   
                    (onContextMenuPreparing)="onContextMenuPreparing($event)">
                    
                    <dxo-data-grid-load-panel [enabled]="true"></dxo-data-grid-load-panel>                                        

                    <dxi-data-grid-column cssClass="dx-grid-cell-wrapped" caption="Portfolio Name" width="300" alignment="left" [calculateCellValue]="dxGetPortfolioNameForPortfolioGrid"></dxi-data-grid-column>
                    <dxi-data-grid-column cssClass="dx-grid-cell" dataField="isActive" caption="Portfolio Access Status" alignment="left" cellTemplate="activeTemplate" ></dxi-data-grid-column>
                    <div *dxTemplate="let cellData of 'activeTemplate'">
                        <div *ngIf="cellData.row.data.isActive">
                            <span class="status-badge badge-active">Active</span>
                        </div>
                        <div *ngIf="!cellData.row.data.isActive">
                            <span class="status-badge badge-inactive">Inactive</span>
                        </div>
                    </div>   
                    
                    <dxi-data-grid-column cssClass="dx-grid-cell" alignment="right" cellTemplate="actionMenu">
                        <div *dxTemplate="let cellData of 'actionMenu'">                
                            <dx-button 
                                id="btnShowPortfolioActionMenu"
                                hint="Action Menu"
                                [hoverStateEnabled]="false"
                                [activeStateEnabled]="false"
                                stylingMode="text" 
                                type="normal" 
                                icon="overflow" 
                                (onClick)="showActionMenu($event)">
                            </dx-button>                  
                        </div>
                    </dxi-data-grid-column>

                    <dxo-data-grid-scrolling rowRenderingMode="virtual"></dxo-data-grid-scrolling>
                    <dxo-data-grid-paging [pageSize]="10"> </dxo-data-grid-paging>
                    <dxo-data-grid-pager
                        [visible]="true"
                        [allowedPageSizes]="[5, 10, 20, 'all']"
                        [displayMode]="'compact'"
                        [showPageSizeSelector]="true"
                        [showInfo]="true"
                        [showNavigationButtons]="true">
                    </dxo-data-grid-pager>
                </dx-data-grid>
            </div>

            <!-- Properties Table -->
            <div class="row margin-top-20">
                <h3>User Properties</h3>
                <dx-data-grid
                    #dxAdminUserPropertiesDataGrid
                    id="adminUserPropertiesDataGrid"
                    [dataSource]="user?.userProperties"
                    [showColumnLines]="false"
                    [showRowLines]="true"
                    [showBorders]="false"
                    (onRowPrepared)="dxGridRowPrepared($event)"
                    (onContextMenuPreparing)="onContextMenuPreparing($event)">

                    <dxo-data-grid-load-panel [enabled]="true"></dxo-data-grid-load-panel>
                    
                    <dxi-data-grid-column cssClass="dx-grid-cell-wrapped" dataField="propertyName" caption="Property Name" alignment="left" width="300"></dxi-data-grid-column>                    
                    <dxi-data-grid-column cssClass="dx-grid-cell-wrapped" caption="Portfolio Name" alignment="left" [calculateCellValue]="dxGetPortfolioNameForPropertyGrid"></dxi-data-grid-column>

                    <dxi-data-grid-column cssClass="dx-grid-cell" dataField="isActive" caption="Property Status" alignment="left" cellTemplate="propertyActiveTemplate" ></dxi-data-grid-column>
                    <div *dxTemplate="let cellData of 'propertyActiveTemplate'">
                        <div *ngIf="cellData.row.data.propertyIsActive">
                            <span class="status-badge badge-active">Active</span>
                        </div>
                        <div *ngIf="!cellData.row.data.propertyIsActive">
                            <span class="status-badge badge-inactive">Inactive</span>
                        </div>
                    </div>       
                    
                    <dxi-data-grid-column cssClass="dx-grid-cell" alignment="right" cellTemplate="actionMenu">
                        <div *dxTemplate="let cellData of 'actionMenu'">                
                            <dx-button 
                                id="btnShowPropertyActionMenu"
                                hint="Action Menu"
                                [hoverStateEnabled]="false"
                                [activeStateEnabled]="false"
                                stylingMode="text" 
                                type="normal" 
                                icon="overflow" 
                                (onClick)="showActionMenu($event)">
                            </dx-button>                  
                        </div>
                    </dxi-data-grid-column>

                    <dxo-data-grid-scrolling rowRenderingMode="virtual"></dxo-data-grid-scrolling>
                    <dxo-data-grid-paging [pageSize]="10"> </dxo-data-grid-paging>
                    <dxo-data-grid-pager
                        [visible]="true"
                        [allowedPageSizes]="[5, 10, 20, 'all']"
                        [displayMode]="'compact'"
                        [showPageSizeSelector]="true"
                        [showInfo]="true"
                        [showNavigationButtons]="true">
                    </dxo-data-grid-pager>
                </dx-data-grid>
            </div>
        </section>        
    </div>
</section>
